const LightboxHook = {
  mounted() {
    $(this.el).magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
      },
    });
  },
};

export default LightboxHook;
